import { CASEPERIPHERAL_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: CASEPERIPHERAL_MNG,
  relationSearch: true,
  allowStatus: {},
  sortArr: [
    {
      fieldName: 'busiVersion',
      direction: 'DESC'
    },
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '请输入用例名',
    moreBtnWidth: 160,
    searchFieldNameArr: ['testCaseName'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'casePeripheralCreate'
      }
      // {
      //   slot: 'refresh-rigtht',
      //   label: '批量升级产品版本',
      //   props: {
      //     type: 'primary',
      //     icon: 'el-icon-plus'
      //   },
      //   action: 'batchUpdatePeripheralProduct'
      // }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '用例名',
          prop: 'testCaseName',
          sortField: 'testCaseName'
        }
      },
      {
        props: {
          label: '用例编号',
          prop: 'testCaseCode'
        }
      },
      {
        props: {
          label: '适用范围',
          prop: 'relevant',
          sortField: 'relevant'
        },
        dataType: 'enum',
        dictionaryPath: 'relevant'
      },
      {
        props: {
          label: 'testcaseMng.testCaseContent',
          prop: 'testCaseContent'
        }
      },
      {
        props: {
          label: 'testcaseMng.testCaseScene',
          prop: 'testCaseScene'
        }
      },
      {
        props: {
          label: '用户诉求',
          prop: 'userDemand'
        }
      },
      {
        props: {
          label: '用例步骤',
          prop: 'testCaseStep'
        }
      },
      {
        props: {
          label: 'testcaseMng.testCaseExpectedResult',
          prop: 'testCaseExpectedResult'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          sortField: 'updateTime'
        },
        dataType: 'date'
      },
      {
        props: {
          label: '业务版本号',
          prop: 'busiVersion',
          sortField: 'busiVersion'
        }
      },
      {
        //操作
        props: {
          showBtnNum: '2'
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: 'edit',
        command: 'casePeripheralEdit',
        name: 'edit'
      },
      {
        icon: 'el-icon-delete',
        label: 'delete',
        command: 'casePeripheralDelete',
        name: 'delete',
        confirm: {
          msg: 'tips.confirm.casePeripheralMng.deleteMsg'
        }
      }
    ]
  }
}
